document.addEventListener("DOMContentLoaded", function () {
  const dialog = document.getElementById("formDialog");
  const triggers = document.querySelectorAll(".menu-dialog-trigger");
  const closeBtn = document.getElementById("closeDialog");

  // Add event listeners for each trigger
  triggers.forEach((trigger) => {
    trigger.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default link behavior if it's a link
      dialog.showModal();

      // Remove any inline 'display: none' styles set by Gravity Forms
      const formWrapper = dialog.querySelector(".gform_wrapper");
      if (formWrapper) {
        formWrapper.style.display = "block";
      }
    });
  });

  // Add event listener for close button
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      dialog.close();
    });
  }

  // Fix Gravity Form display after rendering
  window.addEventListener("gform_post_render", function () {
    const formWrapper = dialog.querySelector(".gform_wrapper");
    if (formWrapper) {
      formWrapper.style.display = "block";
    }
  });
});
